import { render } from "./help-content.vue?vue&type=template&id=33b31c9b&scoped=true"
import script from "./help-content.vue?vue&type=script&lang=js"
export * from "./help-content.vue?vue&type=script&lang=js"

import "./help-content.vue?vue&type=style&index=0&id=33b31c9b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b31c9b"]])

export default __exports__